import { BaseStoryCardElementMixin } from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import StoryCardClickBehavior from "%/dynamic-component-editor/options/story-card-click-behavior";
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";
import StoryMetadataIcon from "%/dynamic-component-editor/standard-components/base-story-card/StoryMetadataIcon.vue";
import BaseDynamicComponent from "%/dynamic-component-editor/classes/base-dynamic-component";
import {
  metadataElementName,
  descriptorKey,
  soleStoryTypeForFieldKey,
  storyTypeLabel,
  readMetadataValue,
} from "%/dynamic-components/render-engine/constants/story-type-metadata-fields";
import dayjs from "dayjs";

const elementCache = {};
const NON_BREAKING_SPACE = " ";

function metadataValue(entity, key) {
  const value = readMetadataValue(entity?.metadata, key);
  return value === "" || value === null || value === undefined ? "" : value;
}

export function createStoryMetadataElement(field) {
  const name = metadataElementName(field.key);
  if (elementCache[name]) {
    return elementCache[name];
  }

  const owningStoryType = soleStoryTypeForFieldKey(field.key);

  if (field.input_type === "icon") {
    const iconElement = {
      name,
      extends: StoryMetadataIcon,
      mixins: [BaseStoryCardElementMixin],
      elementPanelSettings: {
        folder: owningStoryType === "" ? "" : storyTypeLabel(owningStoryType),
        displayName: "Story Icon",
        displayIcon: "image",
        elementType: "element",
        elementGroup: "storyElements",
      },
      computed: {
        metadataIconName() {
          return metadataValue(this.entity, field.key);
        },
      },
    };

    BaseDynamicComponent.processElementVueComponents([iconElement]);

    elementCache[name] = iconElement;
    return iconElement;
  }

  const element = {
    name,
    extends: UrlElement,
    mixins: [BaseStoryCardElementMixin],
    elementPanelSettings: {
      folder: owningStoryType === "" ? "" : storyTypeLabel(owningStoryType),
      displayName: field.label,
      displayIcon: "text-alt",
      elementType: "element",
      elementGroup: "storyElements",
    },
    options: [
      StoryCardClickBehavior,
    ],
    computed: {
      label() {
        const value = metadataValue(this.entity, field.key);
        if (value === "") {
          return "";
        }
        if (field.input_type === "number_descriptor") {
          const descriptor = metadataValue(this.entity, descriptorKey(field.key));
          if (descriptor === "") {
            return value;
          }
          return `${value}${NON_BREAKING_SPACE}${descriptor}`;
        }
        if (field.input_type === "date") {
          const timestamp = Number(value);
          if (!Number.isNaN(timestamp) && timestamp > 0) {
            return dayjs.unix(timestamp).format("MMM D, YYYY");
          }
        }
        if (Array.isArray(field.options)) {
          const selectedOption = field.options.find(option => option.value === value);
          if (selectedOption) {
            return selectedOption.label;
          }
        }
        return value;
      },
      computedHref() {
        return this.storyHref;
      },
    },
  };

  BaseDynamicComponent.processElementVueComponents([element]);

  elementCache[name] = element;
  return element;
}
